/* eslint-disable import/no-anonymous-default-export */

import createAxios from "./httpCommon";
import Error from "./error";
import { useNavigate } from "react-router-dom";
import { trackEvent } from "../mixpanel";
// import { trackAddToWishlist, transformPath } from '../App';
import { getParsedLocalStorageItem } from "../components/Navbar/Navbar";
import {
  localStorageGetItem,
  localStorageSetItem,
  localStorageRemoveItem,
} from "../App";
import {
  trackAddToWishlist,
  trackInitiateCheckout,
  trackPurchase,
} from "./tracking";
import {
  trackOmnisendPaymentAttempt,
  trackOmnisendPaymentAttemptFailed,
  trackOmnisendAddedToWishlist,
} from "../omnisend";
import {
  getProductId,
  getProductName,
  getProductPrice,
  sanitizeProductName,
} from "../utils";

export default () => {
  const { error } = Error();
  const navigate = useNavigate();
  const userData = getParsedLocalStorageItem("userData");

  const removefromWishlist = (
    productId,
    setLoading,
    showToast,
    apiWishlistItems,
    setApiWishlistItems,
    callback, // Add this parameter for the callback function
  ) => {
    setLoading(true);
    const token = localStorageGetItem("userToken");

    createAxios().then((axios) => {
      axios
        .post(
          `/order/wishlist/${productId}`,
          {},
          {
            headers: {
              "X-Auth-Token": token,
            },
          },
        )
        .then((response) => {
          setLoading(false);
          showToast({
            toastText: "Item removed from Wishlist!",
            isSuccess: true,
          });

          // const updatedWishlistItems = apiWishlistItems.filter(item => item?.id !== productId);

          setApiWishlistItems(response?.data?.wishlist?.wishlist);
          localStorageSetItem(
            "wishlistItems",
            JSON.stringify(response?.data?.wishlist?.wishlist),
          );
          const totalWishlistItems =
            response?.data?.wishlist?.pagination?.totalWishlistItems;
          localStorageSetItem(
            "totalWishlistItems",
            totalWishlistItems.toString(),
          ); // Ensure the number is converted to a string

          const product = apiWishlistItems.find(
            (p) => (p?.product?.id || p?.box?.id) === productId,
          );
          trackEvent(
            `${
              product?.product?.productName || product?.box?.name
            } Removed from Wishlist`,
            {
              "Product ID": productId,
              "Product Name":
                product?.product?.productName || product?.box?.name,
              User: userData?.email || "Anonymous",
            },
          );
          trackAddToWishlist(
            productId,
            product?.product?.productName || product?.box?.name,
            "Remove from Wishlist",
            userData && userData,
          );

          if (callback) callback(); // Call the callback function if provided
        })
        .catch((e) => {
          // setLoading(false);
          const retriesDone = e.config["axios-retry"]
            ? e.config["axios-retry"].retryCount >= 1
            : true;
          error(e, setLoading, showToast, retriesDone);
        });
    });
  };

  const updateWishlist = (
    productId,
    showToast,
    filledHearts,
    setFilledHearts,
    apiWishlistItems,
    setApiWishlistItems,
    products,
  ) => {
    const token = localStorageGetItem("userToken");

    return createAxios().then((axios) =>
      axios
        .post(
          `/order/wishlist/${productId}`,
          {},
          {
            headers: {
              "X-Auth-Token": token,
            },
          },
        )
        .then((response) => {
          const newState = !filledHearts[productId];
          setFilledHearts((prevState) => {
            const newState = {
              ...prevState,
              [productId]: !prevState[productId],
            };

            return newState;
          });

          showToast({
            toastText: newState
              ? "Item added to Wishlist!"
              : "Item removed from Wishlist!",
            isSuccess: true,
          });

          // let updatedWishlist = apiWishlistItems;
          const productToAdd = products.find(
            (product) => product?.id === productId,
          );

          setApiWishlistItems(response?.data?.wishlist?.wishlist);
          localStorageSetItem(
            "wishlistItems",
            JSON.stringify(response?.data?.wishlist?.wishlist),
          );
          const totalWishlistItems =
            response?.data?.wishlist?.pagination?.totalWishlistItems;
          localStorageSetItem("totalWishlistItems", totalWishlistItems);

          if (productToAdd) {
            trackEvent(
              newState
                ? `${
                    productToAdd.productName || productToAdd?.name
                  } Added to Wishlist`
                : `${
                    productToAdd.productName || productToAdd?.name
                  } Removed from Wishlist`,
              {
                "Product ID": productId,
                "Product Name": productToAdd.productName || productToAdd?.name,
                User: userData?.email || "Anonymous",
              },
            );
            if (newState && userData?.email) {
              const sanitizedProductName = sanitizeProductName(
                getProductName(productToAdd),
              );
              const productId = productToAdd?.sku;
              trackOmnisendAddedToWishlist(userData?.email, {
                id: getProductId(productToAdd),
                title: getProductName(productToAdd),
                price: getProductPrice(productToAdd),
                image: productToAdd.productImage || productToAdd.boxImage,
                url: productToAdd?.boxImage
                  ? `${window.location.origin}/foodbundles`
                  : `${window.location.origin}/products/${sanitizedProductName}/${productId}`,
              });
            }
            trackAddToWishlist(
              productId,
              productToAdd.productName || productToAdd?.name,
              newState ? "Add to Wishlist" : "Remove from Wishlist",
              userData && userData,
            );
          }
        })
        .catch((e) => {
          console.error(e);
          const retriesDone = e.config["axios-retry"]
            ? e.config["axios-retry"].retryCount >= 1
            : true;
          error(e, showToast, retriesDone);
        }),
    );
  };

  const updateSingleWishlist = (
    productId,
    showToast,
    isHeartFilled,
    setIsHeartFilled,
    apiWishlistItems,
    setApiWishlistItems,
    globalProducts,
  ) => {
    const token = localStorageGetItem("userToken");

    return createAxios().then((axios) =>
      axios
        .post(
          `/order/wishlist/${productId}`,
          {},
          {
            headers: {
              "X-Auth-Token": token,
            },
          },
        )
        .then((response) => {
          const newState = !isHeartFilled;
          setIsHeartFilled(newState);

          let toastText = "";
          if (newState) {
            // Add to wishlist if not already present
            const productToAdd = globalProducts?.find(
              (product) => product?.id === productId,
            );
            if (
              !apiWishlistItems.some(
                (item) => (item?.product?.id || item?.box?.id) === productId,
              )
            ) {
              apiWishlistItems.push(productToAdd);
              toastText = "Item added to Wishlist!";
            }
            // trackAddToWishlist(productId, productToAdd.productName);
          } else {
            // Remove from wishlist if present
            if (
              apiWishlistItems.some(
                (item) => (item?.product?.id || item?.box?.id) === productId,
              )
            ) {
              apiWishlistItems = apiWishlistItems.filter(
                (item) => (item?.product?.id || item?.box?.id) !== productId,
              );
              toastText = "Item removed from Wishlist!";
            }
          }

          // Update local storage and state
          // localStorageSetItem('apiWishlistItems', JSON.stringify(wishlist));
          setApiWishlistItems(response?.data?.wishlist?.wishlist);
          localStorageSetItem(
            "wishlistItems",
            JSON.stringify(response?.data?.wishlist?.wishlist),
          );
          const totalWishlistItems =
            response?.data?.wishlist?.pagination?.totalWishlistItems;
          localStorageSetItem("totalWishlistItems", totalWishlistItems);
          const product = globalProducts?.find((p) => p?.id === productId);
          trackEvent(
            newState
              ? `${product?.productName || product?.name} Added to Wishlist`
              : `${
                  product?.productName || product?.name
                } Removed from Wishlist`,
            {
              "Product ID": productId,
              "Product Name": product?.productName || product?.name,
              User: userData?.email || "Anonymous",
            },
          );
          if (newState && userData?.email) {
            const sanitizedProductName = sanitizeProductName(
              getProductName(product),
            );
            const productId = product?.sku;
            trackOmnisendAddedToWishlist(userData?.email, {
              id: getProductId(product),
              title: getProductName(product),
              price: getProductPrice(product),
              image: product.productImage || product.boxImage,
              url: product?.boxImage
                ? `${window.location.origin}/foodbundles`
                : `${window.location.origin}/products/${sanitizedProductName}/${productId}`,
            });
          }
          trackAddToWishlist(
            productId,
            product?.productName || product?.name,
            newState ? "Add to Wishlist" : "Remove from Wishlist",
            userData && userData,
          );
          // Show the appropriate toast message
          showToast({
            toastText: toastText,
            isSuccess: true,
          });
        })
        .catch((e) => {
          const retriesDone = e.config["axios-retry"]
            ? e.config["axios-retry"].retryCount >= 1
            : true;
          error(e, showToast, retriesDone);
        }),
    );
  };

  const getWishlist = (
    setLoading,
    showToast,
    setApiWishlistItems,
    pagination = null,
    setPagination = null,
    isMobile = false,
  ) => {
    let currentPage = 1;
    let itemsPerPage = 20;

    if (pagination) {
      currentPage = pagination.currentPage;
      itemsPerPage = pagination.itemsPerPage;
    }

    setLoading(true);
    const token = localStorageGetItem("userToken");

    createAxios().then((axios) => {
      axios
        .get(`/order/wishlist?page=${currentPage}&limit=${itemsPerPage}`, {
          headers: {
            "X-Auth-Token": token,
          },
        })
        .then((response) => {
          // Fetch the wishlist items from the API
          const apiWishlistItems = response?.data?.wishlist?.wishlist;

          localStorageSetItem(
            "wishlistItems",
            JSON.stringify(apiWishlistItems),
          );
          if (isMobile) {
            // On mobile, concatenate new globalProducts with existing ones
            setApiWishlistItems((prevWishlist) => {
              const uniqueWishlist = apiWishlistItems.filter(
                (newWishlist) =>
                  !prevWishlist.some(
                    (existingWishlist) =>
                      existingWishlist?.id === newWishlist?.id,
                  ),
              );
              return [...prevWishlist, ...uniqueWishlist];
            });
          } else {
            // On larger screens, replace wishlist

            setApiWishlistItems(apiWishlistItems);
          }

          const totalWishlistItems =
            response?.data?.wishlist?.pagination?.totalWishlistItems;
          localStorageSetItem("totalWishlistItems", totalWishlistItems);

          if (setPagination) {
            const { totalPages, totalWishlistItems } =
              response?.data?.wishlist?.pagination;
            setPagination({
              currentPage,
              itemsPerPage,
              totalPages: totalPages,
              totalWishlistItems: totalWishlistItems,
            });
          }
          setTimeout(() => {
            setLoading(false);
          }, 1000);
        })
        .catch((e) => {
          // setLoading(false);
          const retriesDone = e.config["axios-retry"]
            ? e.config["axios-retry"].retryCount >= 1
            : true;
          error(e, setLoading, showToast, retriesDone);
        });
    });
  };
  const getMoreWishlistItems = (
    setLoadingMore,
    showToast,
    setApiWishlistItems,
    pagination = null,
    setPagination = null,
  ) => {
    let currentPage = 1;
    let itemsPerPage = 20;

    if (pagination) {
      currentPage = pagination.currentPage;
      itemsPerPage = pagination.itemsPerPage;
    }

    setLoadingMore(true);
    const token = localStorageGetItem("userToken");

    createAxios().then((axios) => {
      axios
        .get(`/order/wishlist?page=${currentPage}&limit=${itemsPerPage}`, {
          headers: {
            "X-Auth-Token": token,
          },
        })
        .then((response) => {
          // Fetch the wishlist items from the API
          const apiWishlistItems = response?.data?.wishlist?.wishlist;

          setApiWishlistItems((prevWishlist) => {
            // Combine previous globalProducts with new ones
            const combinedWishlist = [...prevWishlist, ...apiWishlistItems];

            return combinedWishlist.reduce((acc, current) => {
              const x = acc.find((item) => item?.id === current?.id);
              if (!x) {
                return acc.concat([current]);
              } else {
                return acc;
              }
            }, []);
          });

          const totalWishlistItems =
            response?.data?.wishlist?.pagination?.totalWishlistItems;
          localStorageSetItem("totalWishlistItems", totalWishlistItems);

          // Update pagination state with details from the response
          if (setPagination) {
            const { totalPages, totalWishlistItems } =
              response?.data?.wishlist?.pagination;
            setPagination({
              currentPage,
              itemsPerPage,
              totalPages: totalPages,
              totalWishlistItems: totalWishlistItems,
            });
          }
          setTimeout(() => {
            setLoadingMore(false);
          }, 1000);
        })
        .catch((e) => {
          const retriesDone = e.config["axios-retry"]
            ? e.config["axios-retry"].retryCount >= 1
            : true;
          error(e, showToast, retriesDone);
        });
    });
  };

  const applyPromotion = (
    body,
    setDiscount,
    setLoyaltyCode,
    setPromotionDescription,
    setDiscountDescription,
    setDiscountType,
    setDeliveryDiscount,
    setPercentageAmountCap,
    setDiscountPercentage,
    setMinOrderAmount,
    setLoading,
    setIsSuccessful,
    showToast,
    setProductCategories,
  ) => {
    setLoading(true);
    const token = localStorageGetItem("userToken");
    const userData = getParsedLocalStorageItem("userData");
    createAxios().then((axios) => {
      axios
        .post("/order/promotions/value", body, {
          headers: {
            "X-Auth-Token": token,
          },
        })
        .then(async (response) => {
          setLoading(false);
          trackEvent("Valid Promo Code ", {
            User: userData?.email,
            attempted_at: new Date().toISOString(),
          });
          setLoyaltyCode("");
          if (
            response?.data?.data?.promotionType ===
              "percentage off individual products" &&
            response?.data?.data?.discountType === "percentage"
          ) {
            setDiscount(response?.data?.data?.value);
          } else if (response?.data?.data?.discountType === "percentage") {
            setDiscountPercentage(response?.data?.data?.percentage);
            setDiscountType(response?.data?.data?.discountType);
            const discountPercentage = response?.data?.data?.percentage;
            const calculatedDiscount =
              (body.totalCostAmount * discountPercentage) / 100;
            setDiscount(calculatedDiscount);
          } else if (
            response?.data?.data?.discountType === "percentage and amount"
          ) {
            setDiscountPercentage(response?.data?.data?.percentage);
            setDiscountType(response?.data?.data?.discountType);
            const discountPercentage = response?.data?.data?.percentage;
            const calculatedDiscount =
              (body.totalCostAmount * discountPercentage) / 100;
            setDiscount(calculatedDiscount);
            if (
              response?.data?.data?.promotionType ===
              "free delivery & percentage off product"
            ) {
              setDeliveryDiscount(response?.data?.data?.amount);
            }
          } else {
            if (response?.data?.data?.promotionType === "free delivery") {
              setDiscount(0);
              setDeliveryDiscount(response?.data?.data?.value);
            } else {
              setDiscount(response?.data?.data?.value);
            }

            setDiscountType(response?.data?.data?.discountType);
          }

          setDiscountDescription(response?.data?.data?.promotionType);
          setPromotionDescription(response?.data?.data?.description);
          if (response?.data?.data?.percentageAmountCap !== 0) {
            setPercentageAmountCap(response?.data?.data?.percentageAmountCap);
          }
          if (response?.data?.data?.minOrderAmount !== 0) {
            setMinOrderAmount(response?.data?.data?.minOrderAmount);
          }
          setIsSuccessful(true);
          setProductCategories(response?.data?.data?.productCategory || []);
          showToast({
            toastText: "Code valid",
            isSuccess: true,
          });
        })

        .catch((e) => {
          setIsSuccessful(false);
          const retriesDone = e.config["axios-retry"]
            ? e.config["axios-retry"].retryCount >= 1
            : true;
          error(e, setLoading, showToast, retriesDone);

          trackEvent("Invalid Promo Code", {
            User: userData?.email,
            failure_reason:
              e.response?.data?.message ||
              e.message ||
              "An unexpected error occurred",
            attempted_at: new Date().toISOString(),
          });
        });
    });
  };
  const applyLoyaltyDiscount = async (
    body,
    setDiscount,
    setLoyaltyCode,
    setDeliveryDiscount,
    setPromotionDescription,
    setDiscountDescription,
    setDiscountType,
    setPercentageAmountCap,
    setDiscountPercentage,
    setMinOrderAmount,
    setLoading,
    showToast,
  ) => {
    setLoading(true);
    const token = localStorageGetItem("userToken");
    const userData = getParsedLocalStorageItem("userData");

    try {
      const axiosInstance = await createAxios();
      const response = await axiosInstance.post(
        "/order/promotions/loyalty-coupon",
        body,
        {
          headers: { "X-Auth-Token": token },
        },
      );

      setLoading(false);
      const data = response?.data?.data;
      const organizationDiscount = response?.data?.meta?.organizationDiscount;

      if (organizationDiscount?.isEligible) {
        setLoyaltyCode("organizationDiscount");
        setDiscount(organizationDiscount.discountAmount);
        setDiscountPercentage(organizationDiscount.discountPercentage);
        setPromotionDescription(
          `Organization Discount: ${organizationDiscount.organizationName}`,
        );
        setDiscountDescription("organization discount");
        setDiscountType("amount");
        return;
      } else if (!data) {
        setLoyaltyCode("");
        setDiscount(0);
        setDiscountPercentage(0);
        setPromotionDescription("");
        setDiscountDescription("");
        setDiscountType("");
        return;
      }

      const couponCode =
        typeof data.couponCode === "string" ? data.couponCode.trim() : "";
      setLoyaltyCode(couponCode);

      setPromotionDescription(data.description || "");
      setDiscountDescription(data.promotionType || "");
      setDiscountType(data.discountType || "");

      if (data.percentageAmountCap && data.percentageAmountCap !== 0) {
        setPercentageAmountCap(data.percentageAmountCap);
      }

      if (data.minOrderAmount && data.minOrderAmount !== 0) {
        setMinOrderAmount(data.minOrderAmount);
      }

      // Handle each loyalty type clearly
      const desc = data.description?.toLowerCase() || "";
      const promoType = data.promotionType?.toLowerCase() || "";

      if (desc === "loyalty discount after 5 orders") {
        // Percentage or flat loyalty
        if (data.discountType === "percentage" && data.percentage) {
          const calculatedDiscount =
            (body.totalCostAmount * data.percentage) / 100;
          setDiscountPercentage(data.percentage);
          setDiscount(calculatedDiscount);
        } else if (data.amount) {
          setDiscount(data.amount);
        }
      } else if (
        desc ===
        "loyalty discount for customers with over 500,000 total order value"
      ) {
        // Free delivery type
        if (promoType === "free delivery") {
          setDeliveryDiscount(50000);
          setDiscount(0);
        } else if (data.value) {
          setDiscount(data.value);
        }
      }
    } catch (e) {
      setLoading(false);

      const retriesDone = e.config?.["axios-retry"]
        ? e.config["axios-retry"].retryCount >= 1
        : true;

      error(e, setLoading, showToast, retriesDone);
    }
  };

  const applyVoucher = (
    body,
    setLoyaltyCode,
    setVoucherDiscount,
    setLoading,
    setIsSuccessful,
    showToast,
  ) => {
    setLoading(true);
    const token = localStorageGetItem("userToken");
    const userData = getParsedLocalStorageItem("userData");
    createAxios().then((axios) => {
      axios
        .post("/vouchers/value", body, {
          headers: {
            "X-Auth-Token": token,
          },
        })
        .then(async (response) => {
          setLoading(false);

          trackEvent("Valid Voucher Code ", {
            User: userData?.email,
            attempted_at: new Date().toISOString(),
          });
          setLoyaltyCode("");
          setVoucherDiscount(response?.data?.amount);
          setIsSuccessful(true);
          showToast({
            toastText: "Code valid",
            isSuccess: true,
          });
        })

        .catch((e) => {
          setIsSuccessful(false);
          const retriesDone = e.config["axios-retry"]
            ? e.config["axios-retry"].retryCount >= 1
            : true;
          error(e, setLoading, showToast, retriesDone);

          trackEvent("Invalid Voucher Code", {
            User: userData?.email,
            failure_reason:
              e.response?.data?.message ||
              e.message ||
              "An unexpected error occurred",
            attempted_at: new Date().toISOString(),
          });
        });
    });
  };

  const checkout = (body, setLoading, showToast, discountApplied) => {
    setLoading(true);
    const carts = body.carts.map((item) => ({
      productId: item.productId,
      quantity: item.quantity,
      productName: item.productName,
    }));
    const token = localStorageGetItem("userToken");
    const userData = getParsedLocalStorageItem("userData");
    createAxios().then((axios) => {
      axios
        .post("/order/checkout", body, {
          headers: {
            "X-Auth-Token": token,
          },
        })
        .then(async (response) => {
          setLoading(false);

          if (response?.status === 200 && response?.data?.paymentUrl) {
            trackInitiateCheckout(
              "success",
              "Initiate Checkout",
              carts.length,
              carts,
              userData && userData,
            );

            trackEvent("Successful Payment Attempt", {
              User: userData?.email,
              "Order-Items": body.carts.map((item) => ({
                productId: item.productId,
                quantity: item.quantity,
                productName: item.productName,
              })),

              "Delivery Type": body.deliveryType,
              "Discount Applied": discountApplied,
            });

            trackOmnisendPaymentAttempt(userData?.email, {
              total: response?.data?.order?.totalCost,
              discount: discountApplied,
              deliveryType: body.deliveryType,
              products: body?.carts?.map((item) => ({
                id: item.productId,
                title: item.productName,
                price: item.price || item?.amount,
                quantity: item.quantity,
                image: item.productImage || item?.boxImage,
              })),
            });
            localStorageSetItem(
              "transactionReference",
              response?.data?.transaction_reference,
            );
            localStorageSetItem("paymentUrl", response?.data?.paymentUrl);
            setTimeout(() => {
              localStorageRemoveItem("order_reviewed_fingerprint");
              localStorageRemoveItem("order_reviewed_timestamp");
              window.location.href = response?.data?.paymentUrl;
            }, 1000);
          } else {
            showToast({
              toastText: "Payment URL failed",
              isSuccess: false,
            });

            trackInitiateCheckout(
              "failure",
              "Initiate Checkout",
              carts.length,
              carts,
              userData && userData,
            );

            trackEvent("Failed Paystack Redirect", {
              User: userData?.email,
              // failure_reason: e.response?.data?.message || e.message || 'An unexpected error occurred',
              failure_reason: "An unexpected error occurred",
              attempted_at: new Date().toISOString(),
            });
          }
        })

        .catch((e) => {
          const retriesDone = e.config["axios-retry"]
            ? e.config["axios-retry"].retryCount >= 1
            : true;
          error(e, setLoading, showToast, retriesDone);
          const reason =
            e?.response?.data?.message ||
            e?.message ||
            "An unexpected error occurred";
          trackEvent("Unsuccessful Payment Attempt", {
            User: userData?.email,
            failure_reason: reason,
            attempted_at: new Date().toISOString(),
          });
          trackOmnisendPaymentAttemptFailed(userData.email, reason);

          // trackInitiateCheckout('failure', carts.length, carts);
        });
    });
  };

  const getOrders = (setLoading, showToast, setOrderDetails) => {
    setLoading(true);
    const token = localStorageGetItem("userToken");

    createAxios().then((axios) => {
      axios
        .get("/order", {
          headers: {
            "X-Auth-Token": token,
          },
        })
        .then(async (response) => {
          setOrderDetails(response?.data?.data);
          setTimeout(() => {
            setLoading(false);
          }, 1000);
        })

        .catch((e) => {
          // setLoading(false);

          const retriesDone = e.config["axios-retry"]
            ? e.config["axios-retry"].retryCount >= 1
            : true;
          error(e, setLoading, showToast, retriesDone);
        });
    });
  };

  const getSingleOrder = (
    orderId,
    setOrderLoading,
    showToast,
    setOrderDetail,
  ) => {
    setOrderLoading(true);
    const token = localStorageGetItem("userToken");

    createAxios().then((axios) => {
      axios
        .get(`/order/${orderId}`, {
          headers: {
            "X-Auth-Token": token,
          },
        })
        .then(async (response) => {
          setOrderDetail(response?.data?.data);
          setTimeout(() => {
            setOrderLoading(false);
          }, 1000);
        })

        .catch((e) => {
          // setOrderLoading(false);

          const retriesDone = e.config["axios-retry"]
            ? e.config["axios-retry"].retryCount >= 1
            : true;
          error(e, setOrderLoading, showToast, retriesDone);
        });
    });
  };

  const getOrderByRef = (
    transactionRef,
    setLoading,
    showToast,
    setOrderDetail,
    setShowPaymentModal,
    setCartItems,
  ) => {
    setLoading(true);

    const userData = getParsedLocalStorageItem("userData");

    createAxios()
      .then((axios) => {
        const pollInterval = 5000; // 5 seconds
        let retryCount = 0;
        const maxRetries = 3;
        let polling;

        const pollOrderStatus = async () => {
          try {
            const response = await axios.get(
              `/order/confirm/${transactionRef}`,
            );

            if (response.status === 200) {
              setLoading(false);

              // Define a flag to prevent multiple event tracking
              const trackedKey = `order_tracked_${transactionRef}`;
              const isAlreadyTracked = localStorageGetItem(trackedKey);

              if (
                response?.data?.order?.orderMod &&
                Object.keys(response?.data?.order?.orderMod)?.length > 0
              ) {
                if (!isAlreadyTracked) {
                  trackEvent("Successful Order Modification", {
                    User: userData?.email,
                    attempted_at: new Date().toISOString(),
                    "Order-Items": response?.data?.order?.orderMod?.cart.map(
                      (item) => ({
                        price:
                          item?.price ??
                          item?.productId?.price ??
                          item?.box?.amount ??
                          0,
                        quantity: item.quantity,
                        productName: item.productId?.productName,
                      }),
                    ),
                  });
                  trackPurchase(
                    transactionRef,
                    response?.data?.order?.orderMod?.totalCost ??
                      response?.data?.order?.totalCost,
                    "Successful Order Modification",
                  );

                  localStorageSetItem(trackedKey, "true");
                }

                setOrderDetail(response?.data?.order);
                localStorageRemoveItem("paymentUrl");
                clearInterval(polling);
                return;
              }

              if (
                response?.data?.order?.boxes &&
                Object.keys(response?.data?.order?.boxes).length > 0
              ) {
                if (!isAlreadyTracked) {
                  trackEvent("Successful Subscription", {
                    User: userData?.email,
                    attempted_at: new Date().toISOString(),
                    Box: response?.data?.order?.boxes?.box?.name,
                    Quantity: response?.data?.order?.boxes?.quantity,
                  });
                  trackPurchase(
                    transactionRef,
                    response?.data?.order?.totalCost,
                    "Successful Subscription",
                  );

                  localStorageSetItem(trackedKey, "true");
                }

                setOrderDetail(response?.data?.order);
                localStorageRemoveItem("paymentUrl");
                clearInterval(polling);
                return;
              }

              if (
                response?.data?.order?.cart &&
                response?.data?.order?.cart?.length > 0 &&
                response?.data?.order?.paymentStatus === "success"
              ) {
                if (!isAlreadyTracked) {
                  trackEvent("Successful Checkout", {
                    User: userData?.email,
                    attempted_at: new Date().toISOString(),
                    "Order-Items": response?.data?.order?.cart?.map((item) => ({
                      price:
                        item?.price ??
                        item?.productId?.price ??
                        item?.box?.amount ??
                        0,
                      quantity: item.quantity,
                      productName: item.productId?.productName,
                    })),
                  });
                  trackPurchase(
                    transactionRef,
                    response?.data?.order?.totalCost,
                    "Successful Order",
                  );

                  localStorageSetItem(trackedKey, "true");
                }

                setCartItems([]);
                localStorageRemoveItem("cartItems");
                setOrderDetail(response?.data?.order);
                localStorageRemoveItem("paymentUrl");
                clearInterval(polling);
                return;
              }

              if (
                response?.data?.order?.purchasedVoucher &&
                Object.keys(response?.data?.order?.purchasedVoucher)?.length > 0
              ) {
                if (!isAlreadyTracked) {
                  trackEvent("Successful Voucher Purchase", {
                    User: userData?.email,
                    attempted_at: new Date().toISOString(),
                    "Voucher Name":
                      response?.data?.order?.purchasedVoucher?.voucher?.name,
                  });
                  trackPurchase(
                    transactionRef,
                    response?.data?.order?.purchasedVoucher?.voucher?.amount ??
                      response?.data?.order?.totalCost,
                    "Successful Voucher Purchase",
                  );
                  localStorageSetItem(trackedKey, "true");
                }

                setOrderDetail(response?.data?.order);
                localStorageRemoveItem("paymentUrl");
                clearInterval(polling);
                return;
              }

              // Handle unsuccessful cases only if no successful event was tracked
              if (
                response?.data?.order?.paymentStatus === "failed" ||
                response?.data?.order?.orderMod?.paymentStatus === "failed" ||
                Object.keys(response?.data?.order?.boxes).length === 0 ||
                Object.keys(response?.data?.order?.purchasedVoucher)?.length ===
                  0
              ) {
                if (!isAlreadyTracked) {
                  let eventName = "";

                  if (response?.data?.order?.paymentStatus === "failed") {
                    eventName = "Unsuccessful Checkout";
                  } else if (
                    response?.data?.order?.orderMod?.paymentStatus === "failed"
                  ) {
                    eventName = "Unsuccessful Order Modification";
                  } else if (
                    Object.keys(response?.data?.order?.boxes).length === 0
                  ) {
                    eventName = "Unsuccessful Subscription";
                  } else if (
                    Object.keys(response?.data?.order?.purchasedVoucher)
                      ?.length === 0
                  ) {
                    eventName = "Unsuccessful Voucher Purchase";
                  }

                  trackEvent(eventName, {
                    User: userData?.email,
                    failure_reason: "An unexpected error occurred",
                    attempted_at: new Date().toISOString(),
                  });
                  localStorageSetItem(trackedKey, "true");
                }

                setShowPaymentModal(true);
                clearInterval(polling);
              }
            }
          } catch (e) {
            retryCount++;

            if (e.response?.status === 400 || retryCount >= maxRetries) {
              clearInterval(polling);
              error(e, setLoading, showToast, retryCount >= maxRetries);
            }
          }
        };

        polling = setInterval(pollOrderStatus, pollInterval); // Start polling
      })
      .catch((e) => {
        const retriesDone = e.config["axios-retry"]
          ? e.config["axios-retry"].retryCount >= 1
          : true;
        error(e, setLoading, showToast, retriesDone);
      });
  };

  const getDeliveryStates = (showToast, setDeliveryStates) => {
    // setLoading(true);

    createAxios().then((axios) => {
      axios
        .get("/location/state/user")
        .then(async (response) => {
          setDeliveryStates(response?.data);
        })

        .catch((e) => {
          // setLoading(false);

          const retriesDone = e.config["axios-retry"]
            ? e.config["axios-retry"].retryCount >= 1
            : true;
          error(e, showToast, retriesDone);
        });
    });
  };
  const orderModify = (orderId, body, setLoading, showToast) => {
    setLoading(true);

    const token = localStorageGetItem("userToken");
    const userData = getParsedLocalStorageItem("userData");
    createAxios().then((axios) => {
      axios
        .post(`/order/${orderId}/modify`, body, {
          headers: {
            "X-Auth-Token": token,
          },
        })
        .then(async (response) => {
          setLoading(false);

          if (response?.status === 200 && response?.data?.paymentUrl) {
            trackEvent("Successful Order Modification Payment Attempt", {
              User: userData?.email,
              "Order-Items": body.cart.map((item) => ({
                productId: item?.productId?.id || item?.box?.id,
                quantity: item?.quantity,
                productName:
                  item?.productId?.productName ||
                  item?.productId?.name ||
                  item?.box?.name,
              })),
            });
            trackInitiateCheckout(
              "success",
              "Initiate Order Modification",
              "",
              body?.cart,
              userData && userData,
            );
            localStorageSetItem("paymentUrl", response?.data?.paymentUrl);
            localStorageSetItem(
              "transactionReference",
              response?.data?.transaction_reference,
            );
            window.location.href = response?.data?.paymentUrl;
          } else {
            showToast({
              toastText: "Payment URL failed",
              isSuccess: false,
            });

            // trackInitiateCheckout('failure', carts.length, carts);

            trackEvent("Failed Paystack Redirect", {
              User: userData?.email,
              // failure_reason: e.response?.data?.message || e.message || 'An unexpected error occurred',
              failure_reason: "An unexpected error occurred",
              attempted_at: new Date().toISOString(),
            });
          }
        })

        .catch((e) => {
          // eslint-disable-next-line no-unused-vars
          const retriesDone = e?.config["axios-retry"]
            ? e?.config["axios-retry"]?.retryCount >= 1
            : true;

          trackEvent("Unsuccessful Order Modification Payment Attempt", {
            User: userData?.email,
            failure_reason:
              e?.response?.data?.message ||
              e?.message ||
              "An unexpected error occurred",
            attempted_at: new Date().toISOString(),
          });
          trackInitiateCheckout(
            "failure",
            "Initiate Order Modification",
            "",
            body?.cart,
            userData && userData,
          );
          error(e, setLoading, showToast.retriesDone);
        });
    });
  };

  const subscribe = (body, subscription, setLoading, showToast) => {
    setLoading(true);

    const token = localStorageGetItem("userToken");
    const userData = getParsedLocalStorageItem("userData");
    createAxios().then((axios) => {
      axios
        .post("/subscription/subscribe", body, {
          headers: {
            "X-Auth-Token": token,
          },
        })
        .then(async (response) => {
          setLoading(false);

          if (response?.status === 200 && response?.data?.data?.paymentUrl) {
            trackEvent("Successful Subscription Attempt", {
              User: userData?.email,
              "Order-Items": {
                boxName: subscription.name,
                boxId: subscription.id,
                quantity: body?.boxes?.quantity,
              },
            });
            trackInitiateCheckout(
              "success",
              "Initiate Subscription",
              body?.boxes?.quantity,
              subscription.name,
              userData && userData,
            );
            localStorageSetItem("paymentUrl", response?.data?.data?.paymentUrl);
            localStorageSetItem(
              "transactionReference",
              response?.data?.data?.transaction_reference,
            );
            window.location.href = response?.data?.data?.paymentUrl;
          } else {
            showToast({
              toastText: "Payment URL failed",
              isSuccess: false,
            });

            trackEvent("Failed Paystack Redirect", {
              User: userData?.email,

              failure_reason: "An unexpected error occurred",
              attempted_at: new Date().toISOString(),
            });
          }
        })

        .catch((e) => {
          const retriesDone = e.config["axios-retry"]
            ? e.config["axios-retry"].retryCount >= 1
            : true;
          error(e, setLoading, showToast, retriesDone);

          trackEvent("Unsuccessful Subscription Attempt", {
            User: userData?.email,
            failure_reason:
              e?.response?.data?.message ||
              e?.message ||
              "An unexpected error occurred",
            attempted_at: new Date().toISOString(),
          });
          trackInitiateCheckout(
            "failure",
            "Initiate Subscription",
            body?.boxes?.quantity,
            subscription.name,
            userData && userData,
          );
        });
    });
  };

  const deleteSubscription = (
    subscriptionId,
    subscription,
    body,
    setLoading,
    showToast,
  ) => {
    const token = localStorageGetItem("userToken");
    const userData = getParsedLocalStorageItem("userData");
    setLoading(true);
    createAxios().then((axios) => {
      axios
        .post(`/subscription/subscribe/${subscriptionId}`, body, {
          headers: {
            "X-Auth-Token": token,
          },
        })
        .then((response) => {
          setLoading(false);
          showToast({
            toastText: "Subscription cancelled",
            isSuccess: true,
          });

          trackEvent(" Subscription Cancelled", {
            User: userData?.email,
            "Box Name": subscription?.boxes?.box?.name,
          });
          setTimeout(() => {
            navigate("/profile/subscriptions");
          }, 2000);
        })
        .catch((e) => {
          // setLoading(false);
          trackEvent("Unsuccessful Subscription Cancellation", {
            User: userData?.email,
            failure_reason:
              e?.response?.data?.message ||
              e?.message ||
              "An unexpected error occurred",
            attempted_at: new Date().toISOString(),
          });
          const retriesDone = e.config["axios-retry"]
            ? e.config["axios-retry"].retryCount >= 1
            : true;
          error(e, setLoading, showToast, retriesDone);
        });
    });
  };

  const purchaseVoucher = (formData, voucher, setLoading, showToast) => {
    setLoading(true);

    const token = localStorageGetItem("userToken");
    const userData = getParsedLocalStorageItem("userData");

    createAxios().then((axios) => {
      axios
        .post(`/vouchers/${voucher?.id}/purchase`, formData, {
          headers: {
            "X-Auth-Token": token,
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          setLoading(false);

          if (response?.data?.paymentUrl) {
            trackEvent("Successful Voucher Purchase Attempt", {
              User: userData?.email,
              "Order-Items": {
                voucherName: voucher.name,
                voucherId: voucher.id,
              },
            });

            trackInitiateCheckout(
              "success",
              "Initiate Voucher Purchase",
              "1",
              voucher.name,
              userData,
            );

            localStorageSetItem("transactionReference", response.data.tx_ref);

            window.location.href = response.data.paymentUrl;
          } else {
            showToast({
              toastText: "Payment URL failed",
              isSuccess: false,
            });
          }
        })
        .catch((e) => {
          setLoading(false);

          const retriesDone =
            e?.config?.["axios-retry"]?.retryCount >= 1 ?? true;

          error(e, setLoading, showToast, retriesDone);

          trackEvent("Unsuccessful Voucher Purchase Attempt", {
            User: userData?.email,
            failure_reason:
              e?.response?.data?.message ||
              e?.message ||
              "An unexpected error occurred",
            attempted_at: new Date().toISOString(),
          });

          trackInitiateCheckout(
            "failure",
            "Initiate Voucher Purchase",
            "1",
            voucher.name,
            userData,
          );
        });
    });
  };

  return {
    checkout,
    getWishlist,
    updateWishlist,
    removefromWishlist,
    updateSingleWishlist,
    getMoreWishlistItems,
    getOrders,
    getSingleOrder,
    getOrderByRef,
    applyPromotion,
    getDeliveryStates,
    subscribe,
    orderModify,
    deleteSubscription,
    purchaseVoucher,
    applyVoucher,
    applyLoyaltyDiscount,
  };
};
